const routes = [
  {
    path: "/h5/index",
    name: "Index",
    component: () => import("@/views/main.vue")
  },
  {
    path: "/h5/agreement/privacyPolicy",
    name: "privacyPolicy",
    component: () => import("@/views/agreement/privacyPolicy.vue"),
    meta: {
      title: "Privacy Policy"
    }
  },
  {
    path: "/h5/agreement/userAgreement",
    name: "userAgreement",
    component: () => import("@/views/agreement/userAgreement.vue"),
    meta: {
      title: "User Agreement"
    }
  },
  {
    path: "/h5/agreement/privacyPolicyTh",
    name: "privacyPolicyTh",
    component: () => import("@/views/agreement/privacyPolicyTh.vue"),
    meta: {
      title: "นโยบายความเป็นส่วนตัว"
    }
  },
  {
    path: "/h5/agreement/userAgreementTh",
    name: "userAgreementTh",
    component: () => import("@/views/agreement/userAgreementTh.vue"),
    meta: {
      title: "เงื่อนไขการใช้บริการ"
    }
  },
  {
    path: "/h5/agreement/privacyPolicyOKADA",
    name: "privacyPolicy",
    component: () => import("@/views/agreement/privacyPolicyOKADA.vue"),
    meta: {
      title: "Privacy Policy"
    }
  },
  {
    path: "/h5/agreement/userAgreementOKADA",
    name: "userAgreement",
    component: () => import("@/views/agreement/userAgreementOKADA.vue"),
    meta: {
      title: "User Agreement"
    }
  },
  {
    path: "/h5/agreement/privacyPolicyFrOKADA",
    name: "privacyPolicyTh",
    component: () => import("@/views/agreement/privacyPolicyFrOKADA.vue"),
    meta: {
      title: "Politique de confidentialité"
    }
  },
  {
    path: "/h5/agreement/userAgreementFrOKADA",
    name: "userAgreementTh",
    component: () => import("@/views/agreement/userAgreementFrOKADA.vue"),
    meta: {
      title: "Accord de l`utilisateur"
    }
  },
];
export default routes;
